import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const DeliveryDashboardEnhanced = lazy(() => import('./pages/DeliveryDashboardEnhanced'));

// Delivery module routes - main dashboard for delivery management with analytics
const deliveryRoutes: RouteObject[] = [
  {
    index: true,
    element: <DeliveryDashboardEnhanced />,
  },
];

export default deliveryRoutes;
